import axios from 'axios'
import { useCallback } from 'react'

export interface AiExtractedProduct {
    name: string
    type: 'kolonie' | 'polkolonie' | 'wycieczka-szkolna' | 'zielona-szkola' | 'noclegi-dla-grup'
    description: string
    categories: string[]
    min_age?: number
    max_age?: number
    duration_days?: number
    trip_type?: string
    country_code?: string
    country_name?: string
    location?: {
        province?: string
        city?: string
        address?: string
        driving_directions?: string
    }
    location_types?: string[]
    location_name?: string
    transport_type?: string
    transport_description?: string
    food_type?: string
    food_description?: string
    food_vegetarian?: boolean
    food_vegan?: boolean
    insurance_type?: string
    insurance_description?: string
    schedule_description?: string
    schedule?: Array<{ day: number; title: string; description: string }>
    participation_conditions?: string
    conditions_text_short?: string
    conditions_text_long?: string
    additional_info_text?: string
    min_price?: number
    price_description?: string
    price_includes_text?: string
    price_not_includes_text?: string
    discounts_description?: string
    tags?: string[]
    availability?: {
        type?: string
    }
    trips?: Array<{
        name?: string
        start_date?: string
        end_date?: string
        full_price?: number
        advance_price?: number
        available_spots?: number
    }>
}

export const useAiProductsApi = () => {
    const extractProductFromText = useCallback(
        async (text: string): Promise<AiExtractedProduct> => {
            const url =
                process.env.REACT_APP_WAKACJE_API_URL + '/ai-products/extract'
            const res = await axios.post(url, { text })
            return res.data?.data
        },
        []
    )

    return { extractProductFromText }
}
